import { getSoundFileById } from "./notificationSounds";

let currentAudio = null;
let lastPlaybackAt = 0;

let contactAudio = null;
let lastContactPlaybackAt = 0;

// Sonido fijo para asignación de contacto (distinto al de mensajes)
const CONTACT_ASSIGNED_TONE = "ting";

function isAudioPlaying(audio) {
  return Boolean(audio && !audio.paused && !audio.ended);
}

function normalizeVolume(volume) {
  const parsed = Number(volume);

  if (!Number.isFinite(parsed)) {
    return 0.7; // default 70%
  }

  const clamped = Math.max(0, Math.min(100, parsed));
  return clamped / 100;
}

export async function playNotificationSound(toneId, volume, options = {}) {
  const { interrupt = false, minIntervalMs = 0 } = options;

  try {
    const now = Date.now();

    if (minIntervalMs > 0 && now - lastPlaybackAt < minIntervalMs) {
      return currentAudio;
    }

    if (isAudioPlaying(currentAudio)) {
      if (!interrupt) {
        return currentAudio;
      }

      currentAudio.pause();
      currentAudio.currentTime = 0;
      currentAudio = null;
    }

    const soundUrl = getSoundFileById(toneId);
    const audio = new Audio(soundUrl);

    audio.volume = normalizeVolume(volume);

    await new Promise((resolve, reject) => {
      const timeout = setTimeout(() => {
        // Timeout: el browser no pre-cargó a tiempo — intentar reproducir igual
        resolve();
      }, 3000);

      audio.addEventListener(
        "canplay",
        () => {
          clearTimeout(timeout);
          resolve();
        },
        { once: true }
      );

      audio.addEventListener(
        "error",
        (e) => {
          clearTimeout(timeout);
          reject(e);
        },
        { once: true }
      );

      audio.load();
    });

    currentAudio = audio;
    lastPlaybackAt = Date.now();
    await audio.play();

    return audio;
  } catch (error) {
    if (error.name !== "NotAllowedError") {
      console.error("Error al reproducir notificación:", error);
    }
    throw error;
  }
}

export function stopNotificationSound() {
  if (currentAudio) {
    currentAudio.pause();
    currentAudio.currentTime = 0;
    currentAudio = null;
  }
}

export async function playContactAssignedSound(volume, options = {}) {
  const { minIntervalMs = 2000 } = options;

  try {
    const now = Date.now();

    if (minIntervalMs > 0 && now - lastContactPlaybackAt < minIntervalMs) {
      return contactAudio;
    }

    if (contactAudio && !contactAudio.paused && !contactAudio.ended) {
      return contactAudio;
    }

    const soundUrl = getSoundFileById(CONTACT_ASSIGNED_TONE);
    const audio = new Audio(soundUrl);

    audio.volume = normalizeVolume(volume);

    await new Promise((resolve, reject) => {
      const timeout = setTimeout(() => { resolve(); }, 3000);

      audio.addEventListener("canplay", () => { clearTimeout(timeout); resolve(); }, { once: true });
      audio.addEventListener("error", (e) => { clearTimeout(timeout); reject(e); }, { once: true });

      audio.load();
    });

    contactAudio = audio;
    lastContactPlaybackAt = Date.now();
    await audio.play();

    return audio;
  } catch (error) {
    if (error.name !== "NotAllowedError") {
      console.error("Error al reproducir sonido de contacto asignado:", error);
    }
    throw error;
  }
}